import { render, staticRenderFns } from "./LoanRepaymentReport.vue?vue&type=template&id=4072376c&scoped=true"
import script from "./LoanRepaymentReport.vue?vue&type=script&lang=js"
export * from "./LoanRepaymentReport.vue?vue&type=script&lang=js"
import style0 from "./LoanRepaymentReport.vue?vue&type=style&index=0&id=4072376c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072376c",
  null
  
)

export default component.exports